import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'

export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'en' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null

  let title = 'Save big on live TV for your family'
  let subtitle = (
    <>
      {laChannelCount}+ channels of sports, news, novelas, and{' '}
      <span className="desktop-line-break">
        entertainment in Spanish for only{' '}
        <span className="green-underline">${laDiscountPriceMonthly}</span> the first month.
      </span>
    </>
  )
  let pageDescription = `Stream FOX Deportes, ESPN Deportes, beIN SPORTS and more with Fubo.`

  if (latinoBundlePlan?.rsnName) {
    title = 'Watch your local teams'
    let channel = latinoBundlePlan?.rsnName ?? 'FanDuel Sports Network'
    subtitle = `Get ${channel} and ${laChannelCount}+ channels of live TV & sports in Spanish`
    pageDescription = `Stream ${channel}, FOX Deportes, ESPN Deportes, beIN SPORTS and more with Fubo.`
  }

  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/rsn_basketbal_hockey-web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/rsn_basketbal_hockey-mobile.jpg"
      title={title}
      subtitle={subtitle}
      networkSet="entertainmentLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/latino-plus-beisbol-es/"
      pageDescription={pageDescription}
      disableLAPlanCards={isLatinoBundleAvailable}
      forceAnchorLink={isLatinoBundleAvailable}
      hasPlanCards={isLatinoBundleAvailable}
      plans={[latinoBundlePlan]}
    />
  )
}
